import React, { Fragment, useEffect } from 'react';
import {
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  TextField,
  FormGroup,
  FormControlLabel,
  Switch,
  Typography,
} from '@mui/material';
import FilterAccordian from '../filterAccordian';
import Breadcrumb from '../common/breadcrumb';
import { userRequest } from '../../auth/requestMethods';
import DeliveryDining from '@mui/icons-material/DeliveryDining';
import { randomId } from '@mui/x-data-grid-generator';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import { toast } from 'react-toastify';
import CustomTable from '../tables/MuiDataGrid';
import { DataGrid } from '@mui/x-data-grid';
import * as Yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import LastUpdated from '../common/LasUpdated';

const Manage = ({ history }) => {
  useEffect(() => {
    document.title = 'PFSA | Delivery Run Types';
  }, []);
  const [modalState, setModalState] = React.useState({
    update: false,
    open: false,
  });
  const [perPage, setPerPage] = React.useState(10);
  const [page, setPage] = React.useState(1);
  const [dataIsFetching, setDataIsFetching] = React.useState(true);
  const [editTable, setEditTable] = React.useState(false);
  const [isActive, setIsActive] = React.useState(false);
  const [selectionModel, setSelectionModel] = React.useState([]);
  const [deliveryRunTypeSKUs, setDeliveryRunTypeSKUs] = React.useState([]);
  const [updatedDetails, setUpdatedDetails] = React.useState({
    user: '',
    lastUpdated: '',
  });
  const [tableData, setTableData] = React.useState({
    count: 0,
    deliveryRunTypes: [],
  });
  const [searchInput, setSearchInput] = React.useState({
    no_skus: 'All',
    is_active: 'All',
  });
  const [filterOptions, setFilterOptions] = React.useState({ skuTypes: [] });
  const [skuNames, setSkuNames] = React.useState([]);
  // edit table

  const {
    register,
    watch,
    reset,
    trigger,
    // clearErrors,
    handleSubmit,
    formState,
    getValues,
    formState: { errors, isSubmitted },
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues,
  });

  React.useEffect(() => {
    trigger();
    const subscription = watch((value, { name }) => trigger(name));
    return () => subscription.unsubscribe();
  }, [watch, trigger]);

  React.useEffect(() => {
    const fetchItems = async () => {
      if (!modalState.open) {
        try {
          setDataIsFetching(true);

          let queryString = `/delivery-run-types?per_page=${perPage}&page=${page}`;

          queryString += `&no_skus=${searchInput.no_skus}`;
          queryString += `&is_active=${searchInput.is_active}`;
          console.log(queryString);
          if (modalState.statusFilter && modalState.statusFilter !== 'All') {
            queryString += `&status=${modalState.statusFilter.toLowerCase()}`;
          }
          console.log(queryString);

          const { data } = await userRequest().get(`${queryString}`);

          setTableData({
            count: data.total,
            deliveryRunTypes: data.deliveryRunTypes,
          });

          setDataIsFetching(false);

          if (modalState.statusFilter === 'All') {
            const skuNamesResponse = await userRequest().get(`/skus/names`);
            setSkuNames(skuNamesResponse.data.skus);
          }
        } catch (error) {
          setDataIsFetching(false);
          console.error(error);
        }
      }
    };

    fetchItems();
  }, [perPage, page, modalState, searchInput]);

  function buildQuery(foundFilter = null) {
    return Object.entries(searchInput)
      .map(([key, value]) => {
        if (value !== '') {
          if (foundFilter) foundFilter.push(key);

          if (key === 'is_active') {
            // Handle 'All' case separately
            if (value === 'All') {
              return ''; // Return an empty string for 'All' case
            }
            return encodeURIComponent(key) + '=' + encodeURIComponent(value);
          }

          return encodeURIComponent(key) + '=' + encodeURIComponent(value);
        }
        return '';
      })
      .filter((Q) => !!Q)
      .join('&');
  }

  const modalOpen = () => {
    // clearErrors();
    setModalState({ open: true, update: false });
    userRequest()
      .get('/sku-types/names')
      .then(({ data }) => {
        setFilterOptions({
          skuTypes: data.skuTypes,
        });
      })
      .catch((error) => {
        console.log(error);
        toast.error('Could not retrieve sku types');
      });
  };

  const onChangeInput = (e, val, name = null) => {
    if (name) {
      setSearchInput({ ...searchInput, [name]: val });
      console.log('SearchInput iname', searchInput);
    } else {
      setSearchInput({ ...searchInput, [e.target.name]: e.target.value });
      console.log('SearchInput ename', searchInput);
    }
  };
  // Remove OnSearch Function after testing
  // const onSearch = (e) => {
  //   e.preventDefault();

  //   const queryString = buildQuery();

  //   userRequest()
  //     .get(`/delivery-run-types?per_page=${perPage}&page=${page}&${queryString}`)
  //     .then(({ data }) => {
  //       setTableData({ count: data.total, deliveryRunTypes: data.deliveryRunTypes });
  //     })
  //     .catch(({ response }) => {
  //       console.log(response);
  //       setTableData({ count: 0, deliveryRunTypes: [] });
  //     });
  // };

  function bulkAxios(urls = null) {
    if (!urls) return urls;

    let promises = urls.map((req) =>
      userRequest()
        .get(req)
        .then(({ data }) => {
          return data;
        })
        .catch((error) => {
          console.log(error);
          return null;
        })
    );

    return Promise.all(promises);
  }

  function getTypeData(id) {
    bulkAxios(['/sku-types/names', `/delivery-run-types/retrieve/${id}`])
      .then((all) => {
        if (all[0].skuTypes) {
          setFilterOptions({ skuTypes: all[0].skuTypes });
        }
        if (all[1]?.deliveryRunType?.length > 0) {
          setDeliveryRunTypeSKUs(all[1].deliveryRunType);
          setIsActive(all[1].deliveryRunType[0].is_active);
          setSelectionModel(
            all[1].deliveryRunType.reduce((reducer, curr) => {
              if (curr.sku_type_id) reducer.push(curr.sku_type_id);
              return reducer;
            }, [])
          );
        }
      })
      .catch((error) => console.log(error));
  }

  function meetFilterConditions(data, isUpdate = true) {
    if (!isUpdate) {
      if (tableData.count === perPage) return false;
    }
    if (searchInput.is_active === 'All') {
      return true; // Return true to fetch all data without applying the active/inactive filter
    } else {
      // Apply the filter condition based on the selected status (true for active, false for inactive)
      return data.is_active === searchInput.is_active;
    }
  }

  function setStatus(id, data) {
    userRequest()
      .post(`/delivery-run-types/update/${id}`, data)
      .then(() => {
        let fW = [];

        if (meetFilterConditions(data)) {
          fW = tableData.deliveryRunTypes.map((drt) => {
            if (id === drt.id) drt.is_active = !drt.is_active;
            return drt;
          });
        } else {
          fW = tableData.deliveryRunTypes.filter((drt) => drt.id !== id);
        }
        setTableData({
          count: tableData.count,
          deliveryRunTypes: fW,
        });
      })
      .catch(() => {});
  }
  const onSubmit = (data) => {
    if (data) {
      const loadingToastId = toast.info(`${modalState.update ? 'Updating...' : 'Creating...'}`, {
        position: 'bottom-center',
        autoClose: 5000,
        toastId: 'create-loading',
      });

      let api = modalState.update ? `/delivery-run-types/update/${modalState.update}` : '/delivery-run-types';

      // Ensure is_active is provided with a non-null value
      const postData = {
        ...data,
        is_active: true, //is_active should be true by default
      };

      userRequest()
        .post(api, postData) // Use postData instead of data
        .then((res) => {
          toast.dismiss(loadingToastId);
          toast.success(`Successfully ${modalState.update ? 'Updated' : 'Created'}`, {
            position: 'bottom-center',
            autoClose: 5000,
            closeOnClick: true,
            draggable: true,
          });
          reset(defaultValues);
          setModalState({ update: true, open: false });
        })
        .catch(({ response }) => {
          toast.dismiss(loadingToastId);
          toast.error(response?.data?.message || 'Failed', {
            position: 'bottom-center',
            autoClose: 5000,
            closeOnClick: true,
            draggable: true,
          });
        });
    }
  };

  function onBlurName({ target }) {
    if (!formState.isDirty) return null;
    if (!errors.display_name?.message) {
      toast.info(`${modalState.update ? 'Updating...' : 'Creating...'}`, {
        isLoading: true,
        position: 'bottom-center',
        autoClose: 5000,
        toastId: 'create',
      });
      let api = modalState.update ? `/delivery-run-types/update/${modalState.update}` : '/delivery-run-types';
      let req = modalState.update ? { display_name: target.value } : { display_name: target.value, is_active: true };

      userRequest()
        .post(api, req)
        .then(({ data }) => {
          toast.dismiss('create');
          toast.success(`Successfully ${modalState.update ? 'Updated' : 'Created'}`, {
            position: 'bottom-center',
            autoClose: 5000,
            closeOnClick: true,
            draggable: true,
          });
          !modalState.update && setModalState({ open: true, update: data.deliveryRunType?.id });
        })
        .catch(({ response }) => {
          toast.dismiss('create');
          toast.error(response.data?.message || 'failed', {
            position: 'bottom-center',
            autoClose: 5000,
            closeOnClick: true,
            draggable: true,
          });
        });
    }
  }
  function onSelectionModelChange(selections, fail) {
    if (fail?.reason) return null;
    let promises = [];
    let temp = deliveryRunTypeSKUs;
    console.log({ temp });
    console.log(selections);

    selections.forEach((item) => {
      // if not found from selections - create
      let found = temp.find((i) => i.sku_type_id === item);
      if (!found)
        promises.push(
          userRequest().post(`/delivery-run-types/vs-skus`, {
            delivery_run_type_id: temp[0].id,
            sku_type_id: item,
          })
        );
    });

    temp.forEach((item) => {
      // if missing from selectionModel - delete
      if (item.sku_type_id === null) return null;
      let found = selections.find((i) => i === item.sku_type_id);
      if (!found) promises.push(userRequest().post(`/delivery-run-types/vs-skus/delete/${item.vs_id}`));
    });
    console.log({ promises });
    if (promises.length < 1) return null;

    Promise.all(promises)
      .then((all) => {
        all.forEach(({ data }) => {
          if (data?.id) {
            temp = temp.filter((item) => item.vs_id !== data.id);
          } else if (data?.deliveryRunTypeVsSku) {
            temp.push({
              id: temp[0].id,
              display_name: temp[0].display_name,
              vs_id: data.deliveryRunTypeVsSku.id,
              sku_type_id: data.deliveryRunTypeVsSku.sku_type_id,
              is_active: temp[0].is_active,
            });
          }
        });
        /* setSelected*/

        setDeliveryRunTypeSKUs(temp);
        setSelectionModel(selections);
      })
      .catch((error) => {
        console.error(error);
      });
  }

  function getFilters() {
    return Object.entries(searchInput)
      .map(([key, value]) => {
        if (value !== '') {
          if (key === 'no_skus' && value === true) {
            return `SKUs: None`;
          }
          if (key === 'no_skus') {
          }
          if (key === 'no_skus' && value !== true) {
            const selectedSku = skuNames[value];
            if (selectedSku) {
              return selectedSku.display_name;
            } else if (value === 'All') {
              return [];
            }
          }
          if (key === 'is_active') {
            if (value === 'All') {
              return [];
            } else {
              return `Status: ${value ? 'Active' : 'Inactive'}`;
            }
          }
        }
      })
      .filter((x) => x !== undefined && x.length !== 0);
  }

  function onCheckActive({ target }) {
    toast.info('Updating...', {
      isLoading: true,
      position: 'bottom-center',
      toastId: 'active',
      autoClose: 5000,
    });
    const id = modalState.update;
    userRequest()
      .post(`/delivery-run-types/update/${id}`, { is_active: !isActive })
      .then(() => {
        toast.dismiss('active');
        toast.success('Updated', {
          position: 'bottom-center',
          autoClose: 5000,
          closeOnClick: true,
          draggable: true,
        });
        setIsActive(!isActive);
      })
      .catch(({ response }) => {
        toast.dismiss('active');
        toast.error(response.data?.message || 'failed', {
          position: 'bottom-center',
          autoClose: 5000,
          closeOnClick: true,
          draggable: true,
        });
      });
  }

  const actionMethods = {
    toggleEdit: (row) => {
      setModalState({ open: true, update: row.id });
      getTypeData(row.id);
      setUpdatedDetails({
        user: row.username,
        lastUpdated: row.last_updated_datetime,
      });
      reset(
        Object.keys(defaultValues).reduce((reduced, curr) => {
          reduced[curr] = row[curr];
          return reduced;
        }, {})
      );
    },
    toggleActive: (row) => setStatus(row.id, { is_active: !row.is_active }),
  };

  const skuColumns = [
    {
      field: 'display_name',
      headerName: 'SKU',
      flex: 1,
    },
  ];

  const columns = [
    {
      field: 'display_name',
      headerName: 'Delivery Run Type',
      headerAlign: 'left',
      align: 'left',
      flex: 1,
    },
    {
      field: 'skus',
      headerName: 'SKUs',
      type: 'number',
      headerAlign: 'left',
      align: 'left',
      flex: 1,
      cellClassName: ({ value }) => {
        if (!value) return 'text-danger';
      },
    },
    {
      field: 'is_active',
      headerName: 'Status',
      headerAlign: 'left',
      align: 'left',
      flex: 1,
      valueGetter: ({ row }) => (row.is_active ? 'Active' : 'Inactive'),
      renderCell: ({ row }) =>
        row.is_active ? (
          <Typography className="font-success">Active</Typography>
        ) : (
          <Typography className="font-danger">Inactive</Typography>
        ),
    },
  ];

  return (
    <Fragment>
      <Breadcrumb icon={<DeliveryDining />} title="Manage" parent="Delivery Types" />

      <div className="container-fluid">
        <FilterAccordian filters={getFilters()}>
          <form className="theme-form" noValidate="">
            <div className="form-group row mx-0">
              <FormControl>
                <InputLabel id="demo-simple-select-helper-label">SKUs</InputLabel>
                <Select
                  name="no_skus"
                  value={searchInput.no_skus}
                  onChange={onChangeInput}
                  labelId="demo-simple-select-helper-label"
                  id="demo-simple-select-helper"
                  label="SKUs"
                  style={{ fontStyle: searchInput.no_skus === 'All' ? 'italic' : 'normal' }}
                >
                  <MenuItem value={'All'} style={{ fontStyle: 'italic' }}>
                    All
                  </MenuItem>
                  {skuNames.map((sku, index) => (
                    <MenuItem key={`sku-${sku.id}`} value={index}>
                      {sku.display_name}
                    </MenuItem>
                  ))}
                  <MenuItem value={true}>No SKUs For Delivery Run Type</MenuItem>
                </Select>
              </FormControl>
            </div>
            <div className="form-group row mx-0">
              <FormControl>
                <InputLabel id="demo-simple-select-helper-label">Status</InputLabel>
                <Select
                  name="is_active"
                  value={searchInput.is_active}
                  onChange={(e) => onChangeInput(e, e.target.value, 'is_active')}
                  labelId="demo-simple-select-helper-label"
                  id="demo-simple-select-helper"
                  label="Status"
                  style={{ fontStyle: searchInput.is_active === 'All' ? 'italic' : 'normal' }}
                >
                  <MenuItem value={'All'} style={{ fontStyle: 'italic' }}>
                    All
                  </MenuItem>
                  <MenuItem value={true}>Active</MenuItem>
                  <MenuItem value={false}>Inactive</MenuItem>
                </Select>
              </FormControl>
            </div>
          </form>
        </FilterAccordian>
      </div>
      <button onClick={modalOpen} className="btn btn-secondary m-15" type="submit">
        <i className="fa fa-plus fa-xl" aria-hidden="true"></i>
      </button>
      <Modal
        isOpen={modalState.open}
        toggle={() => {
          setModalState({ open: false, update: false });
          reset(defaultValues, {});
          setSelectionModel([]);
          editTable && setEditTable(false);
        }}
        size="xl"
        centered={true}
      >
        <ModalHeader
          toggle={() => {
            setModalState({ open: false, update: false });
            reset(defaultValues, {});
            setSelectionModel([]);
            editTable && setEditTable(false);
          }}
        >
          {modalState.update ? 'Edit' : 'Create'} Delivery Run Type
        </ModalHeader>
        <ModalBody>
          <div className="card-body">
            <form className="theme-form" onSubmit={handleSubmit(onSubmit)}>
              <div className="form-group row">
                <TextField
                  {...register(`display_name`)}
                  error={!!(errors.display_name?.message && isSubmitted && getValues().display_name === '')}
                  label="Name"
                  variant="outlined"
                  // helperText={errors.display_name?.message && isSubmitted ? errors.display_name.message : ''}
                  onBlur={onBlurName}
                />
              </div>
              {modalState.update && (
                <>
                  <div className="d-flex justify-content-start my-4">
                    <FormGroup>
                      <FormControlLabel
                        control={<Switch onChange={() => setEditTable(!editTable)} checked={editTable} />}
                        label="Edit SKU Types"
                        sx={{ margin: 0 }}
                        labelPlacement="start"
                      />
                    </FormGroup>
                  </div>
                  <div className="form-group row">
                    <DataGrid
                      rows={filterOptions.skuTypes}
                      columns={skuColumns}
                      pageSize={5}
                      autoHeight
                      rowsPerPageOptions={[5, 10, 50]}
                      isRowSelectable={(params) => editTable}
                      loading={false} // if saving or deleting, true
                      onSelectionModelChange={onSelectionModelChange}
                      selectionModel={selectionModel}
                      checkboxSelection={true}
                      disableSelectionOnClick
                      experimentalFeatures={{ newEditingApi: true }}
                    />
                  </div>
                </>
              )}

              {modalState.update && <LastUpdated user={updatedDetails.user} datetime={updatedDetails.lastUpdated} />}

              <div className="d-flex justify-content-start my-4">
                {modalState.update && (
                  <FormGroup>
                    <FormControlLabel
                      control={<Switch />}
                      onChange={onCheckActive}
                      checked={isActive}
                      label="Active Status"
                      sx={{ margin: 0 }}
                      labelPlacement="start"
                    />
                  </FormGroup>
                )}
              </div>
              <div>
                <button className="btn btn-primary me-1" type="submit">
                  {modalState.update ? 'Save' : 'Create'}
                </button>
              </div>
            </form>
          </div>
        </ModalBody>
      </Modal>
      <div className="container-fluid">
        <CustomTable
          rows={tableData.deliveryRunTypes}
          actions={actionMethods}
          columns={columns}
          setPageSize={setPerPage}
          setPage={setPage}
          getRowId={() => randomId()}
          rowCount={tableData.count}
          pageSize={perPage}
          loading={dataIsFetching}
          sortModel={[{ field: 'skus', sort: 'asc' }]}
        />
      </div>
    </Fragment>
  );
};

const defaultValues = {
  display_name: '',
};

const validationSchema = Yup.object().shape({
  display_name: Yup.string().required('Required'),
});

function formatDate(date) {
  date = new Date(date);
  var hours = date.getHours();
  var minutes = date.getMinutes();
  var ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour "0" should be "12"
  minutes = minutes < 10 ? '0' + minutes : minutes;
  var strTime = hours + ':' + minutes + ' ' + ampm;
  return (
    date.getDate() +
    '/' +
    new Intl.DateTimeFormat('en', { month: 'short' }).format(date) +
    '/' +
    date.getFullYear() +
    ' ' +
    strTime
  );
}

export default Manage;
